import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import { AuthProvider, RequireAuth } from "./components/AuthProvider";
import { SearchProvider } from "./components/SearchProvider";
import { LoadingProvider } from "./components/LoadingProvider";
import NotifyProvider from "./components/Datatable/NotifyProvider";
import FormErrorProvider from "./components/Datatable/FormErrorProvider";
import globalRouter from "./components/globalRouter";

import MainFrame from "./components/MainFrame";
import { Menu } from "./pages/hermes/Menu";
import hermesLogo from "./components/imgs/hermesLogo.png";

// Telas do módulo Hermes (vindas do anubis-front)
import Dashboard from "./pages/hermes/Dashboard";
import Host from "./pages/hermes/Host";
import Backup from "./pages/hermes/Backup";
import Queue from "./pages/hermes/Queue";
import LogAudit from "./pages/hermes/LogAudit";
import ErrorBackup from "./pages/hermes/ErroBackup";
import Tunnel from "./pages/hermes/Tunnel";
import Role from "./pages/hermes/Role";
import Inventory from "./pages/hermes/Inventory";
import UserMgmt from "./pages/hermes/User";

// Telas específicas do standalone (mantidas)
import LoginPage from "./pages/login/LoginPage";
import Recovery from "./pages/recovery";
import ChangePassword from "./pages/recovery/changePassword";
import LicenseDetailPage from "./pages/LicenseDetailPage";
import LicenseExpiredPage from "./pages/LicenseExpiredPage";
import NotAuthorized from "./pages/NotAuthorized";
import NotFound from "./pages/NotFound";

function GlobalRouterSetup() {
  const navigate = useNavigate();
  globalRouter.navigate = navigate;
  return null;
}

export default function App() {
  return (
    <SearchProvider>
      <LoadingProvider>
        <FormErrorProvider>
          <NotifyProvider>
            <AuthProvider>
              <GlobalRouterSetup />
              <Routes>
                {/* Públicas */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/recovery" element={<Recovery />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/license-expired" element={<LicenseExpiredPage />} />

                {/* Protegidas (layout principal) */}
                <Route
                  path="/"
                  element={
                    <RequireAuth>
                      <MainFrame logo={hermesLogo} menuComponent={<Menu />} />
                    </RequireAuth>
                  }
                >
                  <Route path="" element={<Dashboard />} />
                  <Route path="host" element={<Host />} />
                  <Route path="backup" element={<Backup />} />
                  <Route path="queue" element={<Queue />} />
                  <Route path="audit" element={<LogAudit />} />
                  <Route path="error-backup" element={<ErrorBackup />} />
                  <Route path="tunnel" element={<Tunnel />} />
                  <Route path="role" element={<Role />} />
                  <Route path="inventory" element={<Inventory />} />
                  <Route path="user" element={<UserMgmt />} />
                  <Route path="license-detail" element={<LicenseDetailPage />} />
                  <Route path="403" element={<NotAuthorized />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </AuthProvider>
          </NotifyProvider>
        </FormErrorProvider>
      </LoadingProvider>
    </SearchProvider>
  );
}
